module.exports = __webpack_public_path__ + "static/media/not_paid_cxi.48778c80.png";